import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiProfile } from 'modules/api';
import { UpdateUserData } from 'modules/types/User';
import { PasswordResetData } from 'modules/types/UserPassword';

export const resetPassword = createAsyncThunk(
  'profile/resetPassword',
  async (passwordResetData: PasswordResetData, { rejectWithValue }) => {
    try {
      const response = await ApiProfile.resetPassword(passwordResetData);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const updateProfileData = createAsyncThunk(
  'profile/updateProfileData',
  async (updatedData: UpdateUserData, { rejectWithValue }) => {
    try {
      const response = await ApiProfile.updateProfileData(updatedData);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
